import { type ReactNode } from "react"
import { type ToastT, toast as sonnerToast } from "sonner"
import { Icon } from "../../icon/Icon"

export type ToastArgs = {
  message: ReactNode
  icon?: React.ElementType
}

/**
 * A function that will create a new toast notification - a small message that
 * appears on the screen for a short period of time. Will pop messages using the
 * [Toaster](./Toaster.tsx) component.
 *
 * ```tsx
 * import { toast } from "@tokenterminal/core/ui/messaging/toast/toast"
 *
 * toast({ message: "Hello, world!" })
 * ```
 */

export const toast = ({ message, icon }: ToastArgs): ToastT["id"] => {
  return sonnerToast(
    <div className="flex flex-row w-full">
      <div className="flex flex-row gap-3 items-center">
        {icon && <Icon as={icon} width={16} className="text-fg-secondary" />}
        <div className="text-sm font-medium">{message}</div>
      </div>
    </div>
  )
}
